import { FetchResponse } from '@cian/http-api';

import { IGetUnreadMessagesCountResponseSchema } from '../../../repositories/chats/entities/get_unread_messages/GetUnreadMessagesCountResponseSchema';
import { IErrorResponseSchema } from '../../../repositories/chats/entities/schemas/ErrorResponseSchema';
import {
  fetchGetTotalUnreadMessagesCount,
  TGetTotalUnreadMessagesCountResponse,
} from '../../../repositories/chats/v1/get-total-unread-messages-count';
import { TContext } from '../../../types/context';

export const getTotalUnreadMessagesCount = async ({ logger, httpApi }: TContext): Promise<number> => {
  try {
    const result = await fetchGetTotalUnreadMessagesCount<IGetUnreadMessagesCountResponseSchema, IErrorResponseSchema>({
      httpApi,
    });

    const { response, statusCode } = result as FetchResponse<TGetTotalUnreadMessagesCountResponse>;

    if (statusCode === 200) {
      return response.unread;
    }
  } catch (error) {
    logger.error(error, { description: 'Не удалось получить количество непрочитанных сообщений' });
  }

  return 0;
};
